var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inscription-page" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showInscriptionForm,
                expression: "showInscriptionForm"
              }
            ],
            staticClass: "container",
            attrs: { id: "inscription" }
          },
          [
            _c("h2", [_vm._v("Bulletin d'inscription")]),
            _vm._v(" "),
            _c("inscription-form")
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }